<template>
    <div class="slider-box">
        <div class="slider-box__values">
            <input class="slider-box--input" ref="inputStart"
                   v-bind:value="sliderValue[0]"
                   v-on:input="setStartValue($event.target.value)"
                   v-on:blur="adjustValues"> -
            <input class="slider-box--input" ref="inputEnd"
                   v-bind:value="sliderValue[1]"
                   v-on:input="setEndValue($event.target.value)"
                   v-on:blur="adjustValues">
        </div>
        <div class="slider-box__slider">
            <vue-slider ref="slider" v-bind="sliderAttributes" v-model="sliderValue"></vue-slider>
        </div>
    </div>
</template>

<script>
    import vueSlider from 'vue-slider-component/src/vue2-slider.vue'

    export default {
        props: ['index', 'start', 'end', 'min', 'max'],

        data() {
            return {
                sliderValue: [this.start, this.end],
                sliderAttributes: {
                    min: this.min,
                    max: this.max,
                    show: true,
                    tooltip: false,
                    height: 8,
                    piecewiseStyle: {
                        "backgroundColor": "#3139f2"
                    },
                    processStyle: {
                        "backgroundColor": "rgb(152, 152, 152)"
                    },
                    bgStyle: {
                        "backgroundColor": "#cfcfd4"
                    },
                    class: "vue-slider-class"
                }
            };
        },

        computed: {
            inputStart() {
                return this.sliderValue[0];
            },
            inputEnd() {
                return this.sliderValue[1];
            }
        },

        watch: {
            start(value) {
                this.setStartValue(value);
                this.adjustValues();
            },
            end(value) {
                this.setEndValue(value);
                this.adjustValues();
            },
            sliderValue() {
                this.emitValues();
            }
        },

        methods: {
            setStartValue(value) {
                var parsedValue = this.parseValue(value);
                this.$refs.inputStart.value = parsedValue;

                if (this.inRange(parsedValue, this.min, this.max) && parsedValue <= this.inputEnd) {
                    this.sliderValue = [parsedValue, this.inputEnd];
                }
            },
            setEndValue(value) {
                var parsedValue = this.parseValue(value);
                this.$refs.inputEnd.value = parsedValue;

                if (this.inRange(parsedValue, this.min, this.max) && parsedValue >= this.inputStart) {
                    this.sliderValue = [this.inputStart, parsedValue];
                }
            },
            adjustValues() {
                this.$refs.inputStart.value = Number(this.inputStart);
                this.$refs.inputEnd.value = Number(this.inputEnd);
            },
            emitValues() {
                this.$emit('update', {
                    'index': this.index,
                    'start': Number(this.inputStart),
                    'end': Number(this.inputEnd)
                });
            },
            parseValue(value) {
                return Number((value + '').replace(/[^0-9+\-Ee.]/g, ''));
            },
            inRange(number, start, end) {
                return start <= number && number <= end;
            }
        },

        components: {
            vueSlider
        }
    }
</script>

<style>
    .slider.slider-horizontal {
        width: 500px;
        margin-left: 20px;
        margin-top: 2px;
        float: left;
    }
    .slider-box {
        padding: 4px 0;
        float: left;
    }
    .slider-box__values {
        float: left;
    }
    .slider-box--input {
        width: 50px;
        text-align: center;
    }
    .slider-box__slider {
        margin-top: 1px;
        margin-left: 14px;
        width: 450px;
        float: left;
    }
</style>
